export default function(text) {
  let string_array = text.split(/[ -_]+/);


  string_array = string_array.map((word) => {
    // also need to sanitize each word
    let sanitized = word.replace(/[^a-zA-Z0-9]/g, "")
    return sanitized.charAt(0).toUpperCase() + word.slice(1);
  });

  return string_array.join(' ');
}
